import { makeStyles } from '@material-ui/core/styles';

import { NAVIGATION_BAR_HEIGHT } from 'src/data/common';
import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: 'relative',
      display: 'flex',
      flexFlow: 'column nowrap',
      alignItems: 'stretch',
      marginBottom: theme.spacing(12.5),
      background: COLORS.gray.gray80,
    },
    detailsHeader: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(3),
      padding: theme.spacing(3, 3, 2, 3),
      backgroundColor: COLORS.neutral.white,
      '&$noPaddingBottom': {
        paddingBottom: theme.spacing(0),
      },
    },
    noPaddingBottom: {},
    blurredOverlay: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      inset: 0,
      backdropFilter: 'blur(5px)',

      position: 'absolute',
      height: `calc(100vh - ${NAVIGATION_BAR_HEIGHT}px)`,
      width: '100%',

      '& $blockedMessage': {
        backgroundColor: COLORS.neutral.white,
      },
    },
    blockedMessage: {
      marginTop: theme.spacing(4.5),
    },
    tab: {
      padding: `${theme.spacing(2)}px !important`,
    },
    detailsBody: {
      background: COLORS.gray.gray80,
      padding: theme.spacing(3),
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
    boxGroupTitle: {
      color: COLORS.gray.gray30,
      ...theme.typography.semiBold12,
    },
    groupContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
      marginTop: theme.spacing(1),
    },
    channelPolicyContent: {
      position: 'relative',
    },
  }),
  { name: 'DocumentInsightsPanel' }
);
